// src/pages/Homepage.js

import React, { useState } from "react";
import CardContainer from "../../components/CardContainer/CardContainer";
import CarouselCustom from "../../components/CarouselCustom/CarouselCustom";
import { useNavigate } from "react-router-dom"; // Import useLocation for tracking routes
import "./Homepage.css";

const Homepage = () => {
  const navigate = useNavigate();
  const [isAnimating, setIsAnimating] = useState(false); // State for animation

  const handleCardClick = () => {
    setIsAnimating(true); // Start the animation

    setTimeout(() => {
      // Navigate after the animation duration
      navigate("/produse");
    }, 500); // Match with your CSS animation duration
  };
  return (
    <div className={`homepage ${isAnimating ? "animate" : ""}`}>
      <main>
        <div className="content">
          <CarouselCustom />
        </div>
        <CardContainer onCardClick={handleCardClick} />
      </main>
    </div>
  );
};

export default Homepage;
